import { Link } from 'react-router-dom';
import { experiences } from '../data/experiences';
import { ExperienceCard } from './ExperienceCard';

// Split into two columns; the right column rides lower for a staggered,
// editorial rhythm. Tall images alternate to make the columns interlock.
const mid = Math.ceil(experiences.length / 2);
const leftCol = experiences.slice(0, mid);
const rightCol = experiences.slice(mid);

export function Experiences() {
  return (
    <section id="experiences" className="bg-cream py-20 sm:py-28">
      <div className="container-content section-pad">
        {/* Heading row */}
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="eyebrow">Choose Your Moment</p>
            <h2 className="mt-4 font-display text-[clamp(2.25rem,4.5vw,3.25rem)] font-medium text-charcoal">
              The Experiences
            </h2>
          </div>
          <Link to="/experiences" className="btn btn-outline-dark self-start sm:self-auto">
            See All Experiences
          </Link>
        </div>

        {/* Staggered two-column layout */}
        <div className="mt-12 flex flex-col gap-7 sm:mt-14 md:flex-row md:items-start md:gap-7 lg:gap-8">
          <div className="flex flex-1 flex-col gap-7 lg:gap-8">
            {leftCol.map((exp, i) => (
              <ExperienceCard key={exp.id} exp={exp} tall={i % 2 === 0} imageOverride={exp.homeImage} />
            ))}
          </div>
          <div className="flex flex-1 flex-col gap-7 md:mt-12 lg:mt-16 lg:gap-8">
            {rightCol.map((exp, i) => (
              <ExperienceCard key={exp.id} exp={exp} tall={i % 2 === 1} imageOverride={exp.homeImage} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
